import { reduxKey } from './constants';
export const config = (state)=>state[reduxKey] || {};
export const key = (name)=>(state)=>config(state)[name];
export const getConfig = config;
export const getConfigKey = (state, name)=>config(state)[name];
